import {createContext} from 'react'

export const WindowContext = createContext([])
export const UserContext = createContext([])
export const AgentContext = createContext({})
export const WorkflowsContext = createContext({})
export const SourcesContext = createContext({})
export const DetailContext = createContext(null)
export const LinesContext = createContext(null)
export const PayContext = createContext(null)
